export const INIT_APP = 'CreateFabric/*/Init';
export const SET_EVENT_TO_BACKEND_SNAPSHOT = 'CreateFabric/*/EventToBackendSnapshot';
export const VOLUNTEER_SIGNUP = 'evite/*/VOLUNTEER_SIGNUP';
export const HTTP_STATUS_PAYMENT_REQUIRED = 402;
export const FUNERAL_EVENT_TYPE = 'funeral_memorial_service';

export const CANVAS_HEIGHT = 1350;

export const LOG_LEVELS = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
});

export const UNKNOWN_ERROR_MESSAGE =
  'An unknown error occurred, please try again or contact support.';

export const INACTIVE_OBJECT_TEXT =
  'Click the text or photo on your invitation to activate editing features';

export const DEFAULT_INSTRUCTION_TEXT =
  'Click the text on your invitation or upload a photo to activate editing features';

export const DYO_INSTRUCTION_TEXT = 'Upload a photo to activate editing features';

export const INIT_UNLOCK_STATE = 'CreateFabric/*/InitUnlockState';
export const UNLOCK_STEPS = 'CreateFabric/*/UnlockStep';
